import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var PollingError = /*#__PURE__*/function (_BaseMediaClientError) {
  _inherits(PollingError, _BaseMediaClientError);
  var _super = _createSuper(PollingError);
  function PollingError(reason, attempts) {
    var _this;
    _classCallCheck(this, PollingError);
    _this = _super.call(this, reason);
    _this.reason = reason;
    _this.attempts = attempts;
    return _this;
  }
  _createClass(PollingError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        attempts = this.attempts;
      return {
        reason: reason,
        attempts: attempts
      };
    }
  }]);
  return PollingError;
}(BaseMediaClientError);
export function isPollingError(err) {
  return err instanceof PollingError;
}